import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PageLayout from '../../components/PageLayout/PageLayout';
import {
  VAG_BRANDS,
  HUB_PAGE,
  SITE_PHONE,
  SITE_ADDRESS,
  buildBrandServiceSchema,
  getBrandBySlug,
} from '../../seo/siteSeo';

function BrandLinks({ currentSlug }) {
  return (
    <div className="spg-brand-links">
      {VAG_BRANDS.map((brand) => (
        <RouterLink
          key={brand.slug}
          to={brand.path}
          className={`spg-brand-chip${currentSlug === brand.slug ? ' is-active' : ''}`}
        >
          {brand.shortName}
        </RouterLink>
      ))}
    </div>
  );
}

export function BrandHubPage(props) {
  const { configuration } = props;

  return (
    <PageLayout
      configuration={configuration}
      title="VAG Garage Davos"
      helmetTitle={HUB_PAGE.title}
      description={HUB_PAGE.description}
      path={HUB_PAGE.path}
      includeLocalBusiness
    >
      <section className="spg-section">
        <div className="spg-kicker">{HUB_PAGE.kicker}</div>
        <h1 className="spg-title">{HUB_PAGE.h1}</h1>
        <p className="spg-lead">{HUB_PAGE.lead}</p>
        <p className="spg-lead">
          Das schweizweite stop+go Konzept wird von der AMAG Import AG unterstützt und
          fokussiert auf Volkswagen, Audi, SEAT, Škoda und CUPRA – mit Originalteilen wo
          möglich, Diagnosetechnik und fairen Preisen.
        </p>

        <div className="spg-grid is-brand-cards" style={{ marginTop: 36 }}>
          {VAG_BRANDS.map((brand) => (
            <article key={brand.slug} className="spg-brand-card">
              <div className="spg-kicker">{brand.kicker}</div>
              <h2 className="spg-brand-card-title">{brand.h1}</h2>
              <p>{brand.lead}</p>
              <RouterLink className="spg-btn" to={brand.path}>
                {brand.shortName} Service
              </RouterLink>
            </article>
          ))}
        </div>

        <div className="spg-cta-row">
          <a className="spg-btn" href={`tel:${SITE_PHONE.replace(/\s/g, '')}`}>
            Anrufen {SITE_PHONE}
          </a>
          <RouterLink className="spg-btn-outline" to="/online-termin">
            Online Termin
          </RouterLink>
        </div>
      </section>
    </PageLayout>
  );
}

export default function BrandPage(props) {
  const { configuration, slug } = props;
  const brand = getBrandBySlug(slug);

  if (!brand) {
    return null;
  }

  return (
    <PageLayout
      configuration={configuration}
      title={`${brand.shortName} Service`}
      helmetTitle={brand.title}
      description={brand.description}
      path={brand.path}
      jsonLd={buildBrandServiceSchema(brand)}
      includeLocalBusiness
    >
      <section className="spg-section">
        <div className="spg-kicker">{brand.kicker}</div>
        <h1 className="spg-title">{brand.h1}</h1>
        <p className="spg-lead">{brand.lead}</p>
        <p className="spg-lead">
          Die Sportplatzgarage Gutknecht GmbH an der {SITE_ADDRESS.street} in{' '}
          {SITE_ADDRESS.postalCode} {SITE_ADDRESS.locality} ist offizieller stop+go Partner
          und Spezialist für Service und Reparaturen an Fahrzeugen des Volkswagen-Konzerns.
        </p>

        <BrandLinks currentSlug={brand.slug} />

        <h2 className="spg-subtitle">Leistungen für {brand.brand}</h2>
        <ul className="spg-brand-service-list">
          {brand.services.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        <h2 className="spg-subtitle">Warum stop+go in Davos?</h2>
        <div className="spg-lead">
          <p>
            stop+go steht für fachgerechten Service an VW, Audi, SEAT, Škoda und CUPRA –
            mit Unterstützung der AMAG Import AG, Originalteilen wo möglich und fairen
            Preisen. Ideal, wenn Sie in Davos eine kompetente Alternative zum Markenbetrieb suchen.
          </p>
        </div>

        <div className="spg-cta-row">
          <RouterLink className="spg-btn" to="/online-termin">
            Termin für {brand.shortName} buchen
          </RouterLink>
          <a className="spg-btn-outline" href={`tel:${SITE_PHONE.replace(/\s/g, '')}`}>
            {SITE_PHONE}
          </a>
          <RouterLink className="spg-btn-outline" to="/vag-garage-davos/">
            Alle Marken
          </RouterLink>
        </div>
      </section>
    </PageLayout>
  );
}
